/**
 * Created by H
 * User: huangcan
 * Date: 2019-08-22
 * Time: 14:07
 * tips: searchComponent组件与TableComponent组件在父组件中的通信
 */
export default {
  methods: {
    /**
     * 更新数据
     * @param cb
     * @param newValue
     * @param type
     * @private
     */
    _updateData(cb, newValue, type) {
      cb(this, newValue, type)
      // 没有页码数传递过来
      if (!newValue) {
        const vm = type ? this[type] : this
        if (vm.pagination) vm.pagination.currentPage = 1
      }
    }
  }
}
